import React, { useState } from "react";
import cx from "classnames";
import { Autocomplete, TextField, IconButton, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import {
  AutoCompleteFieldStyled,
  MenuItemStyled,
} from "./auto-complete-field.styles";
import OverflowText from "../../overflow-text/overflow-text";
import { isSomething } from "../../../utils/utils";

export const AutoCompleteField = ({
  name,
  label,
  isRequired,
  value,
  required,
  optional,
  options,
  placeholder = "",
  freeSolo = true,
  disableBackspace = false,
  getOptionLabel,
  getCustomMenuItem,
  onInputChange,
  disableClearable,
  onChange,
  clearOnBlur = false,
  showStar = false,
  toggleStar,
  onStarUpdate,
  starredProjects = [],
  ...rest
}) => {
  const [inputValue, setInputValue] = useState("");
  return (
    <AutoCompleteFieldStyled freeSolo={freeSolo}>
      {label ? (
        <div className="label">
          <Typography variant="body1">
            {label}
            {isRequired && "*"}
          </Typography>
        </div>
      ) : (
        <></>
      )}
      <Autocomplete
        openOnFocus
        value={value}
        freeSolo={freeSolo}
        inputValue={inputValue}
        onChange={onChange}
        options={options}
        forcePopupIcon
        disableClearable={disableClearable}
        onInputChange={(e, val) => {
          setInputValue(val);
        }}
        renderOption={(props, option, item) => {
          const isStarred = starredProjects.includes(option.id);
          return (
            <MenuItemStyled
              {...props}
              key={props?.id}
              className={cx({ "menu-item": !freeSolo })}
              value={option?.value}
              style={{ justifyContent: "space-between", display: "flex" }}
            >
              <OverflowText
                tooltipPlacement={"right"}
                sx={{
                  color: item?.selected ? "#007E91" : "#301D35",
                  fontSize: "14px",
                  width: "300px",
                }}
              >
                {getCustomMenuItem
                  ? getCustomMenuItem(option)
                  : getOptionLabel
                  ? getOptionLabel(option)
                  : option.label ?? option}
              </OverflowText>
              {showStar && (
                <IconButton
                  size="small"
                  onClick={(event) => {
                    event.stopPropagation();
                    const isCurrentlyStarred = starredProjects.includes(
                      option.id
                    );

                    // Update local starredProjects state immediately
                    const updatedStarredProjects = isCurrentlyStarred
                      ? starredProjects.filter((id) => id !== option.id)
                      : [...starredProjects, option.id];
                    toggleStar(option.id); // Assuming this updates the backend
                    onStarUpdate(updatedStarredProjects); // Trigger parent state update
                  }}
                  style={{ color: isStarred ? "#F1D26A" : "#DEDAFB" }}
                >
                  <StarIcon />
                </IconButton>
              )}
            </MenuItemStyled>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            onChange={(e) => onInputChange && onInputChange(e.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Backspace" && disableBackspace) {
                event.stopPropagation();
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment:
                options.length < 1 ? null : params.InputProps.endAdornment,
            }}
            sx={{
              width: "100%",
              "& input": {
                fontSize: "14px",
                color: "#301D35",
                "&::placeholder": {
                  color: "#301D35",
                  opacity: 0.6,
                  fontSize: "14px",
                  fontWeight: 400,
                },
              },
            }}
          />
        )}
        getOptionLabel={getOptionLabel}
        onBlur={(e) => {
          if (clearOnBlur) {
            setInputValue("");
          }
        }}
        {...rest}
      />
    </AutoCompleteFieldStyled>
  );
};

export default AutoCompleteField;
